import React from 'react';
import { ScComponent } from '@/types/interfaces';

export interface TextareaProps extends ScComponent {
  name?: string;
  placeholder?: string;
  disabled?: boolean;
  value: string;
  onChange: (val: string) => void;
}

const Textarea: React.FC<TextareaProps> = ({
  className = '',
  onChange,
  ...props
}) => {
  return (
    <textarea
      id="textarea"
      className={`textarea ${className}`}
      onChange={(evt) => {
        onChange(evt.currentTarget.value);
      }}
      {...props}
    />
  );
};

export default Textarea;
